import { render, staticRenderFns } from "./ItemsReceivedFormModal.vue?vue&type=template&id=9a851358&scoped=true&"
import script from "./ItemsReceivedFormModal.vue?vue&type=script&lang=js&"
export * from "./ItemsReceivedFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a851358",
  null
  
)

export default component.exports